export default "__VITE_ASSET__57c8e733__"